/* SK FAQ - acordeon de preguntas frecuentes */

(function () {
  'use strict';

  /* Inicializa el acordeon de la seccion FAQ */
  function initFaqAccordion() {
    var sections = document.querySelectorAll('.sk-faq');

    sections.forEach(function (section) {
      /* Evitar doble inicializacion */
      if (section.dataset.faqInit) return;
      section.dataset.faqInit = 'true';

      /* Delegacion de eventos en la seccion */
      section.addEventListener('click', function (e) {
        var button = e.target.closest('.sk-faq__question');
        if (!button) return;

        var item = button.closest('.sk-faq__item');
        var answer = item.querySelector('.sk-faq__answer');
        var isOpen = item.classList.contains('sk-faq__item--open');

        /* Cerrar todos los items abiertos */
        var openItems = section.querySelectorAll('.sk-faq__item--open');
        openItems.forEach(function (openItem) {
          if (openItem !== item) {
            closeItem(openItem);
          }
        });

        /* Abrir o cerrar el item actual */
        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item, answer);
        }
      });
    });
  }

  /* Abre un item del acordeon */
  function openItem(item, answer) {
    var inner = answer.querySelector('.sk-faq__answer-inner');
    var button = item.querySelector('.sk-faq__question');

    answer.style.maxHeight = inner.scrollHeight + 'px';
    item.classList.add('sk-faq__item--open');
    button.setAttribute('aria-expanded', 'true');
  }

  /* Cierra un item del acordeon */
  function closeItem(item) {
    var answer = item.querySelector('.sk-faq__answer');
    var button = item.querySelector('.sk-faq__question');

    answer.style.maxHeight = '0';
    item.classList.remove('sk-faq__item--open');
    button.setAttribute('aria-expanded', 'false');
  }

  /* Ejecutar al cargar el DOM */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }

  /* Soporte para el Customizer de Shopify (reiniciar al cambiar seccion) */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.sk-faq')) {
        initFaqAccordion();
      }
    });
  }
})();
